export default __webpack_public_path__ + "src/images/packages/the-coconut-shell/fb79ac48be6854668f9c2a11c082d67a-2.jpeg";